import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { commonVar } from "../../../../providers/common-var/common";
/**
 * Generated class for the FormCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "single-value-card",
  templateUrl: "form-card.html",
})
export class FormCardComponent implements OnInit {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;
  @Input() patientAdmittedDate: string = "";
  @Input() palliativeCareToggle: boolean;

  @Output() onDataUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onCardInitialized: EventEmitter<any> = new EventEmitter();

  label: string;
  declinable: boolean;
  cardData: any;
  creatinineTag: string;
  creatininePreviousAssessment: any;
  dataList: any;

  constructor() {
    // console.log('Hello FormCardComponent Component');
  }

  ngOnInit(): void {
    // console.log( "Card config: " );
    // console.log( this.config );

    this.label = this.config.cardName;
    this.declinable = this.config.declinable;
    this.creatinineTag = commonVar.CREATININE_VALUE;
    if (
      this.config.hasOwnProperty("hisV2") &&
      this.config.hisV2 &&
      (this.config.id === "CL010.302" ||
        this.config.id === "CL010.212" ||
        this.config.id === "CL010.260" ||
        this.config.id === "CL010.213")
    ) {
      this.config.patientAdmittedDate = this.patientAdmittedDate;
    }
  }

  @Input() set data(incomingData: any) {
    // console.log( "Form card Data: ", this.data );
    // console.log( "Form card Incoming data: ", incomingData );
    if (incomingData && incomingData.data && incomingData.data[0]) {
      if (
        (this.config.id == "CL010.289" || this.config.id == "CL010.293") &&
        this.palliativeCareToggle &&
        this.config.subheaderDescription &&
        this.config.subheaderDescription === "formCardWithPrevious"
      ) {
        let data = incomingData.data.filter(
          (x) => x.assessmentId == this.assessmentId.toString()
        )[0];
        this.cardData = data ? data : null;
        this.dataList = incomingData.data;
      } else {
        this.cardData = incomingData.data[0];
        this.creatininePreviousAssessment = incomingData.previous;
      }
    } else if (
      incomingData === null ||
      (incomingData && incomingData.data.length === 0)
    ) {
      this.cardData = null;
      this.creatininePreviousAssessment = null;
    }
  }

  passDataUpdate(data) {
    // pass through data from dynamic form
    // console.log( "Update received in single value card:", data );
    if (data && data.value && this.config.hisV2) {
      data.value.hisV2 = true;
      data.value.patientAdmittedDate = this.patientAdmittedDate;
    }
    this.onDataUpdate.emit(data);
    // console.log("HELP!");
  }

  markCardInitialized(data) {
    // console.log( "Flagging form card as initialized." );
    this.onCardInitialized.emit(data);
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/form-card/form-card.ts